export const ELIGIBILITY_RESPONSE = 'ELIGIBILITY_RESPONSE';

export const setEligibilityData = (data) => ({
  type: ELIGIBILITY_RESPONSE,
  data: data,
});
